import { DataOnlyComponent } from './data-widgets/data-only.component';
import { GridHeaderComponent } from './data-widgets/grid-header.component';
import { PercentDataComponent } from './data-widgets/percent-data.component';
import { RankDataComponent } from './data-widgets/rank-data.component';
import { ReportConfig } from './REPORT_CONFIG';

export const REPORT_CONFIG_DEVICE_MARKET_SHARE: ReportConfig = {
  key: 'device-market-share',
  heading: 'Market Share',
  title: 'Market Share',
  formTitle: 'Device Market Share rankings',
  pageTitle:
    'Market Share for IoT Devices, a Pixalate Rankings index: for {type}',
  pageMeta:
    'IoT Market Share measures estimated market reach for {type} across {countryCode} for {date}.',
  defaultTitleKey: 'Devices',
  reportId: 'iotDeviceMarketShare',
  permissions: ['mrtSellerTrustIndex', 'freemium', 'anonymous'],
  rowLimit: 10,
  fadeStart: 5,
  mainFilterItems: [
    {
      key: 'platformName',
      label: 'OS',
      selected: { label: 'GLOBAL', value: 'GLOBAL' },
      groups: ['app'],
      hidden: true,
      type: 'toggle-filter',
      options: [{ label: 'GLOBAL', value: 'GLOBAL' }]
    },
    {
      key: 'category',
      label: 'Category',
      selected: { label: 'All Categories', value: 'GLOBAL' },
      groups: ['app'],
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'countryCode'
        },
        {
          group: 'app',
          key: 'date'
        },
        {
          group: 'app',
          key: 'platformName'
        }
      ],
      options: [{ label: 'All Categories', value: 'GLOBAL' }],
      default: { label: 'All Categories', value: 'GLOBAL' }
    },
    {
      key: 'countryCode',
      label: 'Region',
      selected: { label: 'North America', value: 'NA' },
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'date'
        },
        {
          group: 'app',
          key: 'platformName'
        },
        {
          group: 'ctv',
          key: 'date'
        }
      ],
      options: [{ label: 'North America', value: 'NA' }],
      default: { label: 'North America', value: 'NA' }
    },
    {
      key: 'countryCode',
      label: 'Country',
      selected: { label: 'All Countries', value: 'GLOBAL' },
      hidden: false,
      dependencies: [
        {
          key: 'date'
        },
        {
          group: 'app',
          key: 'platformName'
        },
        {
          label: 'Region'
        }
      ],
      options: [{ label: 'All Countries', value: 'GLOBAL' }],
      default: { label: 'All Countries', value: 'GLOBAL' }
    },
    {
      key: 'date',
      label: 'Month',
      selected: null,
      hidden: false,
      dependencies: [
        {
          group: 'app',
          key: 'platformName'
        }
      ],
      options: []
    }
  ],
  gridHeaders: [
    {
      label: 'Rank',
      key: 'impressionRank',
      sort: '',
      sortDefault: false,
      sortColumnKey: '',
      hoverKey: '',
      template: null,
      widgetComponent: RankDataComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Device Brand Name',
      key: 'deviceBrandName',
      sort: '',
      groups: ['app'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: DataOnlyComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Platform',
      key: 'platformName',
      sort: '',
      groups: ['ctv'],
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: DataOnlyComponent,
      hidden: false,
      headerWidgetComponent: GridHeaderComponent
    },
    {
      label: 'Estimated Market Reach',
      key: 'impressionSov',
      sort: '',
      sortDefault: false,
      sortColumnKey: null,
      hoverKey: '',
      template: null,
      widgetComponent: PercentDataComponent,
      hidden: false,
      lockIfAnonymous: true,
      lockIfFreemium: true,
      headerWidgetComponent: GridHeaderComponent
    }
  ]
};
